var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenSourceSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0586 2C17.5816 2 22.0586 6.477 22.0586 12C22.0586 16.4 19.2176 20.136 15.2696 21.473L15.0436 21.547L12.1396 13.997C13.2086 13.95 14.0586 13.054 14.0586 12C14.0586 10.895 13.1636 10 12.0586 10C10.9536 10 10.0586 10.895 10.0586 12C10.0586 13.077 10.9096 13.955 11.9756 13.998L9.07259 21.547L8.84759 21.473C4.89859 20.136 2.05859 16.4 2.05859 12C2.05859 6.477 6.53559 2 12.0586 2ZM12.0586 4C7.64059 4 4.05859 7.582 4.05859 12C4.05859 14.92 5.62259 17.475 7.95959 18.872L9.43959 15.023C8.59259 14.29 8.05859 13.207 8.05859 12C8.05859 9.79 9.84859 8 12.0586 8C14.2686 8 16.0586 9.79 16.0586 12C16.0586 13.207 15.5236 14.29 14.6786 15.023C15.2436 16.497 15.7376 17.78 16.1576 18.873C18.4936 17.475 20.0586 14.92 20.0586 12C20.0586 7.582 16.4766 4 12.0586 4Z",
    fill: "#5D2EDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSourceSvgrepoCom1);
export default __webpack_public_path__ + "static/media/open-source-svgrepo-com 1.582ad25ee67ebe8ffbb51d166b035b38.svg";
export { ForwardRef as ReactComponent };